import { UseStore } from '@eastcoal/common/types/zustand'
import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { ImageCardContext } from '../contexts/StoreContext'
import { ImageCardStore } from '../store/interface'

export const useImageCardStore: UseStore<ImageCardStore> = selector => {
  return useContextStore(ImageCardContext, selector)
}

export const useImageCardStoreApi = () => {
  return useContextStoreApi(ImageCardContext)
}
